<div class="multiuse-search-input-wrapper">
	<mat-form-field [ngClass]="{ 'sub-text-active': showSubText }" [style.width]="'100%'" [appearance]="props?.appearance"
		[floatLabel]="props?.floatLabel || auto">
		<span *ngIf="inputSubText" [ngClass]="parentIsModal ? 'sub-text-container__modal' : 'sub-text-container'">{{ inputSubText }}</span>
		<mat-label *ngIf="props.label && !props.hideLabel">{{ props.label }}</mat-label>
		<input matInput [matAutocomplete]="auto" [errorStateMatcher]="errorStateMatcher" [formControl]="inputFormControl" [formlyAttributes]="field"
			[required]="props.required ?? false" (focus)="onFocus()" (blur)="onBlur()" (change)="onInputChanged()"
			[maxlength]="props?.maxLength || 50" questionMarkMask [questionMarkMask]="props?.questionMarkMask"
			[questionMarkMaskUserInputOnly]="props?.questionMarkMaskUserInputOnly || false" [readonly]="props?.disabled || props?.readonly" />
		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionChanged($event.option)">
			<mat-option *ngFor="let option of filteredItems$ | async" [value]="option">
				<div [innerHTML]="option.htmlDisplay"></div>
			</mat-option>
		</mat-autocomplete>
		<mat-spinner *ngIf="isSearching" matSuffix diameter="20"></mat-spinner>
		<mat-icon *ngIf="props?.showCloseIcon && !isSearching" aria-hidden="false" aria-label="Clean" matSuffix (keydown)="removeItem()"
			(click)="removeItem()">close</mat-icon>
		<mat-icon *ngIf="props?.icon && !isSearching" aria-hidden="false" aria-label="Clean" matSuffix [matTooltip]="props?.iconTooltip"
			(keydown)="onIconEvent($event)" (click)="onIconEvent($event)">{{props.icon}}</mat-icon>
		<mat-hint>{{ props?.hint }}</mat-hint>
		<mat-error>
			<formly-validation-message [field]="field"></formly-validation-message>
		</mat-error>
	</mat-form-field>
</div>